<template>
    <div class="params-modal">
        <TitleBaseBox title="添加参数" @confirm="confirmHandle" @close="close">
            <div class="params-content">
                <div class="params-tree">
                    <el-tree :data="paramsData" :props="props" ref="paramsTree" node-key="id" show-checkbox @check="checkHandle">
                        <span class="tree-line" slot-scope="{ node, data }">
                            <i v-show="data.icon" class="tree-icon" :class="data.icon" />
                            <span class="tree-node-span" @mousemove="showParamsType = node.id" @mouseout="showParamsType = null">
                                {{ node.label }}
                                <span class="params-count" v-if="data.count"> ({{ data.count }})</span>
                                <span v-show="showParamsType == node.id" class="params-type">{{ data.disabled ? "已添加" : data.type }}</span>
                            </span>
                        </span>
                    </el-tree>
                </div>
                <div class="params-edit">
                    <div class="edit-title">
                        <span>
                            请选择需要添加的参数， 并填写参数描述
                        </span>
                        <span>
                            已选参数
                            <span :style="{ color: '#03C972' }"> {{ setParamsList.length }}</span>
                        </span>
                    </div>
                    <div>
                        <el-table :data="setParamsList" max-height="470" style="width: 100%">
                            <el-table-column label="参数名称" prop="name"></el-table-column>
                            <el-table-column label="参数类型" prop="type">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.type" placeholder="请选择参数类型">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="参数描述(必填)" width="220">
                                <template slot-scope="scope">
                                    <el-input
                                        type="textarea"
                                        autosize
                                        :class="{ errorInput: errParamArr.indexOf(scope.row.id) !== -1 }"
                                        oninput="value=value.replace(/[<>]/g,'')"
                                        v-model.trim="scope.row.describe"
                                        placeholder="请输入描述"
                                        @change="setDescribe(scope, $event)"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="" width="50">
                                <template slot-scope="scope">
                                    <i class="el-icon-error" @click="delParam(scope, scope.row)"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import { queryConfigParams, addParams } from "../server";
import { cloneDeep } from "lodash";
import Validation from "@/views/zhiji/components/commonForm/validation.js";

export default {
    name: "AddParamsModal",
    props: ["data"],
    components: {
        TitleBaseBox
    },
    data() {
        return {
            props: {
                label: "name",
                children: "children"
            },
            currentSource: "",
            paramsData: [
                {
                    name: "客户端参数",
                    count: 0,
                    id: 0,
                    icon: "el-icon-folder",
                    children: []
                }
            ],
            setParamsList: [],
            showParamsType: false,
            errParamArr: [],
            options: [
                {
                    label: "文本类",
                    value: "string"
                },
                {
                    label: "日期类",
                    value: "datetime"
                },
                {
                    label: "数值类",
                    value: "float"
                },
                {
                    label: "判断类",
                    value: "bool"
                },
            ]
        };
    },
    mounted() {
        this.queryParmasList();
    },
    methods: {
        async queryParmasList() {
            const { list, count } = await queryConfigParams({
                source: 0,
                gameId: this.$store.state.zhiji.gameState.gameId
            });
            this.paramsData[0].children = list;
            this.paramsData[0].count = count;
        },
        close() {
            this.$emit("closeModal");
        },
        async confirmHandle() {
            // 验证参数描述是否有空值
            this.errParamArr = [];
            this.setParamsList.forEach(item => {
                if (!item.describe) {
                    this.errParamArr.push(item.id)
                }
            });
            if (this.errParamArr.length > 0) {
                this.$message.error("请输入描述内容");
            } else {
                // 发请求
                const params = this.setParamsList.map(item => {
                    return {
                        name: item.name,
                        type: item.type,
                        table_name: item.table_name,
                        source: item.source,
                        is_enable: item.is_enable,
                        describe: item.describe,
                        source_value: item.source_value,
                        remark: item.remark || "",
                    }
                })
                const successTotal = await addParams({
                    gameId: this.$store.state.zhiji.gameState.gameId,
                    params,
                })
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: `已成功添加${successTotal}条参数`,
                        confirm: () => {
                            this.close();
                            this.data.confirm();
                        }
                    },
                });
            }
        },
        checkHandle(data, checked) {
            // 获取选中的节点
            const currentChecks = cloneDeep(checked.checkedNodes);
            // 删除一级节点
            currentChecks.forEach((item, index) => {
                if (item.icon) {
                    currentChecks.splice(index, 1)
                }
            })
            // 判断是增还是减
            if (currentChecks.length > this.setParamsList.length) {
                // 添加
                const addData = currentChecks.filter(item => !this.setParamsList.some(param => param.id === item.id));
                this.setParamsList.push(...addData);
            } else {
                // 减少
                this.setParamsList = this.setParamsList.filter(item => currentChecks.some(param => param.id === item.id));
            }
        },
        setDescribe(scope, event) {
            if (event) {
                const hasIndex = this.errParamArr.indexOf(scope.row.id);
                hasIndex !== -1 ? this.errParamArr.splice(hasIndex, 1) : null;
                this.setParamsList[scope.$index].describe = event;
            }
        },
        delParam(scope) {
            this.setParamsList.splice(scope.$index, 1);
            this.$refs.paramsTree.setCheckedNodes(this.setParamsList);
        }
    }
};
</script>

<style lang="less" scoped>
.params-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .params-content {
        display: flex;
        width: 800px;
        height: 500px;
        .params-tree {
            overflow: hidden;
            overflow-y: scroll;
            &::-webkit-scrollbar {
                width: 0;
            }
            flex: 3;
            /deep/.is-disabled .el-checkbox__inner {
                background-color: #2ec2ff;
                opacity: 0.2;
                background-position: -189px 0;
            }
            .tree-icon {
                color: #2ec2ff;
                margin-right: 5px;
                font-size: 16px;
            }
            .tree-line {
                position: relative;
            }
            .tree-node-span {
                display: inline-block;
                width: 130px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                .params-count {
                    font-size: 12px;
                    color: #999999;
                }
                .params-type {
                    position: absolute;
                    right: -10px;
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                    line-height: 16px;
                }
            }
        }
        .params-edit {
            min-width: 0;
            flex: 7;
            border-left: 1px solid #e3ecf5;
            padding-left: 25px;
            .edit-title {
                display: flex;
                justify-content: space-between;
                margin-bottom: 12px;
            }
            /deep/.el-textarea__inner {
                border: 1px solid #d8e4f0;
            }
            .errorInput {
                /deep/.el-textarea__inner {
                    border: 1px solid red;
                }
            }
        }
        .el-icon-error {
            color: #7a7e8e;
            font-size: 14px;
            cursor: pointer;
        }
    }
}
</style>
